export default {
    methods: {
        $formatNumber(number) {
            return parseFloat(Number(number)).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
    },
};
